import axios from 'axios';

const userService = {
    isOPU,
    login,
    register,
    updateUser,
    getUserDetails,
    forgotPassword,
    resetPassword,
    deleteAccount
};

async function login(userCredenatials) {
    return await axios.post('/Account/login/', userCredenatials)
}
async function register(user) {
    return await axios
        .post('/Account/register/', user)
}
async function updateUser(user) {
    return await axios
        .post('Account/updateUser/', user)
}
async function forgotPassword(email) {
    return await axios
        .get(`/Account/forgetPassword?email=${email}`)
}
async function resetPassword(userCredenatials) {
    return await axios.post('/Account/resetPassword/', userCredenatials)
}
async function isOPU() {
    return await axios
        .get(`/Account/isOPU/`)
}
async function getUserDetails() {
    return await axios
        .get(`/Account/userDetails/`)
}
// Self-service account deletion (spec 000001). Proxied through the Mobile BFF to EVMain
// (DELETE /Account/deleteAccount). The bearer token is attached by the axios default header.
async function deleteAccount() {
    return await axios
        .delete(`/Account/deleteAccount/`)
}


export default userService;